<aside id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme">
  <div class="app-brand demo px-1">
    <a class="app-brand-link" [routerLink]="['/home']" routerLinkActive="active">
      <span class="app-brand-logo demo top-right-logo logo-size animate__animated animate__zoomInRight animate__delay-0-4s">
        <img src="../../../assets/img/pendar-logo.png" />
      </span>
      <span class="app-brand-text demo menu-text fw-bold animate__animated animate__backInDown animate__delay-1-6s">
        {{ "APPNameDrugStore" | translate }}
      </span>
    </a>

    <a #closeButton href="javascript:void(0);" class="layout-menu-toggle menu-link text-large ms-auto">
      <i class="bx menu-toggle-icon d-none d-xl-block fs-4 align-middle"></i>
      <i class="bx bx-x d-block d-xl-none bx-sm align-middle"></i>
    </a>
  </div>

  <div class="menu-divider mt-0"></div>

  <!-- <div class="menu-inner-shadow"></div> -->
  <div class="search-container px-3">
    <input (keyup)="searchMenu()" [(ngModel)]="searchedItem" type="text"
      class="form-control px-4 mx-2 container-fluid border-0 search-bg" placeholder="{{ 'search' | translate }} ..."
      aria-label="Search...">
    <button type="button" class="btn-close" *ngIf="searchedItem!=''" (click)="searchedItem='';searchMenu()"></button>
  </div>

  <ul *ngIf="menuList != null" class="menu-inner py-1">

    <!-- Dashboards -->
    <li *ngFor="let item of menuList;let i =index;" class="menu-item" routerLinkActive="active">
      <div class="animate__animated animate__fadeInDown" *ngIf="item.children.length == 0; else other_content"
         [style.animation-delay]="(i*0.2)+'s'">
        <a class="menu-link" [routerLink]="[item.url]"  routerLinkActive="active" (click)="closeMenu()"
          [ngClass]="{ danger: item.url == 'no-action' }">
          <i class="menu-icon tf-icons" [ngClass]="item.icon" [style.color]="item.color"></i>
          <div [attr.data-idvalue]="item.id" [attr.data-idorder]="item.order">
            {{ item.name | translate }}
            <span class="order-hide-number">
              {{item.id}}
            </span>
          </div>
        </a>
      </div>

      <ng-template #other_content>
        <a class="menu-link menu-toggle animate__animated animate__fadeInDown" href="javascript:void(0);"
          routerLinkActive="active" [style.animation-delay]="(i*0.2)+'s'">
          <i class="menu-icon tf-icons" [ngClass]="item.icon" [style.color]="item.color"></i>
          <div [attr.data-idvalue]="item.id" [attr.data-idorder]="item.order">
            {{ item.name | translate }}
            <span class="order-hide-number">
              {{item.order}}
            </span>
          </div>
        </a>
        <ul class="menu-sub">
          <li *ngFor="let child of item.children" class="menu-item" routerLinkActive="active">
            <div *ngIf="child.children.length == 0; else other_child_content">
              <a [routerLink]="[child.url]" class="menu-link ps-3" routerLinkActive="active" (click)="closeMenu()"
                [ngClass]="{ danger: child.url == 'no-action' }">
                <i class="menu-icon tf-icons" [ngClass]="child.icon" [style.color]="child.color"></i>
                <div [attr.data-idvalue]="child.id" [attr.data-idorder]="child.order">
                  {{ child.name | translate }}
                  <span class="order-hide-number">
                    {{child.order}}
                  </span>
                </div>
              </a>
            </div>

            <ng-template #other_child_content>
              <a class="menu-link menu-toggle ps-3" href="javascript:void(0);" routerLinkActive="active">
                <i class="menu-icon tf-icons" [ngClass]="child.icon" [style.color]="child.color"></i>
                <div [attr.data-idvalue]="child.id" [attr.data-idorder]="child.order">
                  {{ child.name | translate}}
                  <span class="order-hide-number">
                    {{child.order}}
                  </span>
                </div>
              </a>
              <ul class="menu-sub second-menu-sub">
                <li *ngFor="let secondchild of child.children" class="menu-item" routerLinkActive="active">
                  <a [routerLink]="[secondchild.url]" class="menu-link ps-4-5" routerLinkActive="active"
                    (click)="closeMenu()" [ngClass]="{ danger: secondchild.url == 'no-action' }">
                    <i class="menu-icon tf-icons" [ngClass]="secondchild.icon" [style.color]="secondchild.color"></i>
                    <div [attr.data-idvalue]="secondchild.id" [attr.data-idorder]="secondchild.order">
                      {{ secondchild.name | translate}}
                      <span class="order-hide-number">
                        {{secondchild.order}}
                      </span>
                    </div>
                  </a>
                </li>
              </ul>
            </ng-template>
          </li>
        </ul>
      </ng-template>
    </li>
  </ul>
  <app-version-tag></app-version-tag>
</aside>